import { WarehouseOrganizationInfoRouteService } from 'common/data';
import { BaseService } from 'core/services';
import { findParams } from 'core/utils';

class WarehouseOrganizationInfoService extends BaseService {
	constructor(apiClient) {
		super(apiClient, new WarehouseOrganizationInfoRouteService());
	}

	find(filter) {
		var url = this.routeService.find(filter);
		return this.apiClient.post(url, findParams(filter));
	}

	adjustInventory(warehouseActivities, sourceOfChange) {
		var url = this.routeService.adjustInventory(warehouseActivities, sourceOfChange);
		return this.apiClient.post(url, warehouseActivities);
	}

	closeOutPalletizing(warehouseId, sourceOfChange) {
		var url = this.routeService.closeOutPalletizing(warehouseId, sourceOfChange);
		return this.apiClient.get(url);
	}

	closeOutExitScan(warehouseId, sourceOfChange) {
		var url = this.routeService.closeOutExitScan(warehouseId, sourceOfChange);
		return this.apiClient.get(url);
	}
}

export default WarehouseOrganizationInfoService;
